import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import { ReactNode } from 'react'

const SECTION_SX_BASE = {
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  position: 'relative',
  gap: 3,
  p: 4,
}

interface FullImageSectionEqProps {
    children?: ReactNode
    image?: string
    height?: string | { xs?: string; md?: string; lg?: string }
    'aria-label'?: string
    [key: string]: any
}

const Index = (props: FullImageSectionEqProps) => {
    const { children, image = '', height = 'auto', ...rest } = props
    const isDev = process.env.NODE_ENV === 'development'
    return (
        <Box
            component={'section'}
            aria-label={rest['aria-label']}
            sx={{
                ...SECTION_SX_BASE,
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.9)), url(${image})`,
                height,
            }}
        >
            {isDev && (
                <Box sx={{width: '100%', position: 'absolute', top: 0}}>
                    <Divider textAlign='left'>
                        <Typography
                            variant='caption'
                            color='secondary'
                        >
                            {rest['aria-label']}
                        </Typography>
                    </Divider>
                </Box>
            )}
            {children}
        </Box>
    )
}

export default Index


